import utils from '@/app/utils/gfUtils';
import HELPER from '@/app/utils/HELPER';

(function (jQuery) {
  jQuery.gfSwatcher = function (element, options) {
    const defaults = {
      targetElement: undefined,
      onOpacity: function () {},
      offOpacity: function () {},
      detectChange: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);

    const _this = this;

    let _jsonData = [];
    let $targetElement;

    let $wrapper;

    let _isRender = true;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      // $ targetElement= _this.settings.targetElement;

      $wrapper = $element.closest('.columns');
      $wrapper.addClass('full');
      $wrapper.addClass('style_swatcher');

      const merId = $gfLeftSideBar.find('#md-settings').data('edittingID');
      $targetElement = $gryffBody.find('#' + merId);

      try {
        let initValue = $element.attr('value');
        initValue = initValue.replace(/'/gi, '"');
        _jsonData = jQuery.parseJSON(initValue);
        _jsonData = _jsonData.filter(function (swatch) {
          if (swatch.custom) {
            return true;
          } else {
            return false;
          }
        });

        const moduleId = $gfLeftSideBar.find('#md-settings').data('edittingID').replace('m-', '');
        const $productSwatches = $gryffBody.find('#m-' + moduleId);

        const $product = $productSwatches.closest('[data-label="Product"]');
        if ($product.children('[data-pid]').length > 0) {
          const productId = $product.children('[data-pid]').attr('data-pid');
          const productData = HELPER.searchProductInList(productId);
          const jsonHtml = '{ "product": ' + JSON.stringify(productData) + '}';
          try {
            var data = jQuery.parseJSON(jsonHtml);
            const swatches = [];
            let swatches_options = data['product']['options'];

            // Sort color up top
            const new_options = [];
            const listDefineColor = [
              'color',
              'kolor',
              'cor',
              'culore',
              'boja',
              'farve',
              'farbe',
              'kleur',
              'koloro',
              'umbala',
              'boja',
              'mtundu',
              'kulay',
              'launi',
              'xim',
              'litur',
              'agba',
              'warna',
              'couleur',
              'väri',
              'цвет',
              'farge',
              'barvy',
              'färg',
              'colore',
            ];
            try {
              for (var j = 0; j < swatches_options.length; j++) {
                if (listDefineColor.indexOf(swatches_options[j].name.toLowerCase()) !== -1) {
                  new_options.unshift(swatches_options[j]);
                } else {
                  new_options.push(swatches_options[j]);
                }
              }
              swatches_options = new_options;
            } catch (error) {}

            for (let i = 0; i < swatches_options.length; i++) {
              for (var j = 0; j < swatches_options[i].values.length; j++) {
                const label = swatches_options[i].values[j];
                let found = false;
                for (let k = 0; k < _jsonData.length; k++)
                  if (_jsonData[k].label.toLowerCase() == label.toLowerCase()) {
                    found = true;
                    break;
                  }
                if (!found) {
                  var data = {
                    label: label,
                    color1: '',
                    color2: '',
                    image: '',
                    custom: false,
                  };
                  swatches.push(data);
                }
              }
            }

            _jsonData.each(function (swatch) {
              swatches.push(swatch);
            });
            _jsonData = swatches;
          } catch (err) {
            console.log(err.message);
          }
        }

        _this.initWithJson();
      } catch (err) {
        console.log(err.message);
      }
      return false;
    };

    this.initWithJson = function (jsonData) {
      if (jsonData != undefined) {
        _jsonData = jsonData;
        _isRender = true;
      }
      this.renderSwatcher();
      this.applyEvents();

      return false;
    };

    this.renderSwatcher = function () {
      try {
        $wrapper.find('.swatcher').remove();
        let html = '<div class="container swatcher">';
        html += '<ul class="items">';
        for (let i = 0; i < _jsonData.length; i++) {
          html += '<li class="item" index="' + i + '">';
          html +=
            '<div class="gfRP_confirm_remove"><button data-action="delete">Delete</button><button data-action="cancel">Cancel</button></div>';

          html +=
            '<span class="gfRP_icon"><span class="gfRP_color" style="background: ' +
            _jsonData[i].color1 +
            '"></span></span>';

          html += '<span class="gfRP_title rp-handle">' + _jsonData[i].label + '</span>';

          html += '<div class="gfRP_right">';
          html += '<span class="rp-remove">' + utils.svgIcon('delete-tool') + '</span>';
          html += '</div>';

          html += '<div class="gfPR_form-items">';
          html += '<div class="gfPR_columns">';
          html += '<div class="gfSGSettings" >';

          html +=
            '<input type="text" class="background-v2" name="background-v2-' +
            i +
            '" data-hide="false" data-type="hidden" data-alpha="true"/>';

          html +=
            '<input type="text" requires="background-v2-' +
            i +
            '|color" data-name="color1" class="gryff-color" value="' +
            _jsonData[i].color1 +
            '" data-alpha="true" data-hide="false" data-type="hidden" style="padding-left: 26px; float: none;">';

          html +=
            '<input type="text" requires="background-v2-' +
            i +
            '|image" data-name="image" class="gf_to-photoPicker ui-dform-text" data-caption="Image" value="' +
            _jsonData[i].image +
            '" data-height="36" />';
          html += '</div>';
          html += '</div>';
          html += '</div>';
          html += '</li>';
        }
        html += '</ul>';
        html += '<div class="swatcherBtnAdd">';
        html +=
          '<svg viewBox="0 0 448 512"><path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z" class=""></path></svg>';
        html += '</div>';
        html += '</div>';

        $element.hide();
        $element.after(html);
      } catch (err) {
        console.log(err.message);
      }
      return false;
    };

    this.applyEvents = function () {
      $wrapper
        .find('.item')
        .off('click')
        .on('click', function (e) {
          if (
            $(e.target).closest('.rp-remove').length == 0 &&
            $(e.target).closest('.gfRP_confirm_remove').length == 0
          ) {
            e.preventDefault();
            const $that = jQuery(this);
            const $item = $that.closest('.item');
            const index = $item.attr('index');

            const $groupFields = $item.find('.gfPR_columns').html();
            const $column = $item.closest('.columns');
            if ($column.data('gfsettinggroup')) {
              const isButton = true;
              $column.data('gfsettinggroup').renderPopup($groupFields, isButton);
              const $gfSGPopup = $column.find('.gfSGPopup');
              const $formElements = $gfSGPopup.find('input,select,checkbox');

              // Update value to input item
              for (var i = 0; i < $formElements.length; i++) {
                var $formElement = $($formElements[i]);
                const name = $formElement.attr('data-name');
                $formElement.attr('value', _jsonData[index][name]).val(_jsonData[index][name]);
              }

              for (var i = 0; i < $formElements.length; i++) {
                var $formElement = jQuery($formElements[i]);

                if ($formElement.hasClass('background-v2')) {
                  $formElement.gfBackgroundV2();
                } else if ($formElement.hasClass('gryff-color')) {
                  $formElement.gfColorPicker({
                    title: $formElement.attr('data-caption'),
                    addHistory: false,
                    onOpacity: function () {
                      if ($wrapper.data('gfsettinggroup')) {
                        $wrapper.data('gfsettinggroup').onOpacity();
                      }
                    },
                    offOpacity: function () {
                      if ($wrapper.data('gfsettinggroup')) {
                        $wrapper.data('gfsettinggroup').offOpacity();
                      }
                    },
                    onHistoryAdded: function () {
                      if ($targetElement) {
                        const extraCount = {
                          label: $targetElement.attr('data-label'),
                          name: 'color-swatches',
                        };
                        if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                          $gryffEditor.data('gfcount').add('setting', extraCount);
                        }
                      }
                    },
                  });
                } else if ($formElement.hasClass('gf_to-photoPicker')) {
                  // Cho stater dung upload care
                  $formElement.gfPhotoPicker({
                    title: $formElement.attr('data-caption'),
                    option: 'noSrc',
                    addHistory: false,
                    onHistoryAdded: function () {
                      if ($targetElement) {
                        const extraCount = {
                          label: $targetElement.attr('data-label'),
                          name: 'image-swatches',
                        };
                        if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                          $gryffEditor.data('gfcount').add('setting', extraCount);
                        }
                      }
                    },
                  });
                } else {
                  $formElement.gfInputField({
                    title: $formElement.attr('data-caption'),
                    addHistory: false,
                    onHistoryAdded: function () {
                      if ($targetElement) {
                        const extraCount = {
                          label: $targetElement.attr('data-label'),
                          name: 'input-swatches',
                        };
                        if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                          $gryffEditor.data('gfcount').add('setting', extraCount);
                        }
                      }
                    },
                  });
                }
                $column.data('gfsettinggroup').checkRequiresV1($formElement);
              }

              $column.data('gfsettinggroup').showPopup($item);

              $gfSGPopup
                .find('.gfSGPopupDone')
                .off('click.savedata')
                .on('click.savedata', function () {
                  const extra = {
                    items: JSON.parse(JSON.stringify(_jsonData)),
                  };
                  $gryffEditor.data('gfhistory').addHistory('repeator', $targetElement.attr('id'), extra);

                  // Save to json
                  for (let i = 0; i < $formElements.length; i++) {
                    const $formElement = $($formElements[i]);
                    const name = $formElement.attr('data-name');
                    const value = $formElement.attr('value');
                    _jsonData[index][name] = value;
                    _jsonData[index].custom = true;
                    // Update color
                    if (name == 'color1') {
                      $item.find('.gfRP_color').css('background', value);
                    }
                  }

                  _this.saveJsonToModule();

                  $column.data('gfsettinggroup').hidePopup();
                });
            }
          }
        });

      $wrapper
        .find('.rp-remove')
        .off('click')
        .on('click', function () {
          const $that = $(this);
          const $li = $that.parent().parent('.item');

          $li.find('.gfRP_confirm_remove').addClass('show');

          $li
            .find('.gfRP_confirm_remove button[data-action="cancel"]')
            .off('click')
            .on('click', function () {
              $li.find('.gfRP_confirm_remove').removeClass('show');
              $li.find('.gfRP_confirm_remove button[data-action="cancel"]').off('click');
              $li.find('.gfRP_confirm_remove button[data-action="delete"]').off('click');
            });
          $li
            .find('.gfRP_confirm_remove button[data-action="delete"]')
            .off('click')
            .on('click', function () {
              const index = $li.attr('index');

              // history
              const extra = {
                items: JSON.parse(JSON.stringify(_jsonData)),
              };
              $gryffEditor.data('gfhistory').addHistory('repeator', $targetElement.attr('id'), extra);

              if ($targetElement) {
                const extraCount = {
                  label: $targetElement.attr('data-label'),
                  name: 'delete-swatches',
                };
                if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                  $gryffEditor.data('gfcount').add('setting', extraCount);
                }
              }

              const count = _jsonData.length;
              if (count <= 1) {
                HELPER.showNotify('You cannot delete all items.', 'error');
              } else {
                _jsonData.splice(index, 1);
                _isRender = true;
                _this.initWithJson();
                _this.saveJsonToModule();
              }

              $li.find('.gfRP_confirm_remove').removeClass('show');
              $li.find('.gfRP_confirm_remove button[data-action="cancel"]').off('click');
              $li.find('.gfRP_confirm_remove button[data-action="delete"]').off('click');
            });
          return false;
        });

      $wrapper
        .find('.swatcherBtnAdd svg')
        .off('click')
        .on('click', function (e) {
          const html =
            '<input type="text" data-name="label" class="" value="" data-caption="Swatch" placeholder="Eg: Green" /><input type="text" class="background-v2" name="background-v2-new" data-hide="false" data-type="hidden" data-alpha="true" style="display: none;"><input type="text" requires="background-v2-new|color" data-name="color1" class="gryff-color" value="" data-alpha="true" data-hide="false" data-type="hidden"><input type="text" requires="background-v2-new|image" data-name="image" class="gf_to-photoPicker ui-dform-text" data-caption="Image" value="">';

          const $that = jQuery(this);
          const $column = $that.closest('.columns');
          if ($column.data('gfsettinggroup')) {
            const isButton = true;
            $column.data('gfsettinggroup').renderPopup(html, isButton);
            const $gfSGPopup = $column.find('.gfSGPopup');
            const $formElements = $gfSGPopup.find('input,select,checkbox');
            for (let i = 0; i < $formElements.length; i++) {
              const $formElement = $($formElements[i]);

              if ($formElement.hasClass('background-v2')) {
                $formElement.gfBackgroundV2();
              } else if ($formElement.hasClass('gryff-color')) {
                $formElement.gfColorPicker({
                  title: $formElement.attr('data-caption'),
                  addHistory: false,
                });
              } else if ($formElement.hasClass('gf_to-photoPicker')) {
                $formElement.gfPhotoPicker({
                  title: $formElement.attr('data-caption'),
                  option: 'noSrc',
                  addHistory: false,
                });
              } else {
                $formElement.gfInputField({
                  title: $formElement.attr('data-caption'),
                  addHistory: false,
                });
              }
              $column.data('gfsettinggroup').checkRequiresV1($formElement);
            }

            $column.data('gfsettinggroup').showPopup($that);

            $gfSGPopup
              .find('.gfSGPopupDone')
              .off('click.savedata')
              .on('click.savedata', function () {
                const extra = {
                  items: JSON.parse(JSON.stringify(_jsonData)),
                };
                $gryffEditor.data('gfhistory').addHistory('repeator', $targetElement.attr('id'), extra);

                if ($targetElement) {
                  const extraCount = {
                    label: $targetElement.attr('data-label'),
                    name: 'new-swatches',
                  };
                  if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                    $gryffEditor.data('gfcount').add('setting', extraCount);
                  }
                }

                const label =
                  typeof $gfSGPopup.find('[data-name="label"]').attr('value') !== 'undefined'
                    ? $gfSGPopup.find('[data-name="label"]').attr('value')
                    : '';
                const color1 =
                  typeof $gfSGPopup.find('[data-name="color1"]').attr('value') !== 'undefined'
                    ? $gfSGPopup.find('[data-name="color1"]').attr('value')
                    : '';
                const color2 =
                  typeof $gfSGPopup.find('[data-name="color2"]').attr('value') !== 'undefined'
                    ? $gfSGPopup.find('[data-name="color2"]').attr('value')
                    : '';
                const image =
                  typeof $gfSGPopup.find('[data-name="image"]').attr('value') !== 'undefined'
                    ? $gfSGPopup.find('[data-name="image"]').attr('value')
                    : '';

                // Validator label
                let found = true;
                for (let j = 0; j < _jsonData.length; j++) {
                  if (_jsonData[j].label == label) {
                    found = false;
                  }
                }

                if (!found) {
                  $gfSGPopup.find('.gfSGPopupError').text('Error: Label swatches already exist');
                } else {
                  $gfSGPopup.find('.gfSGPopupError').text('');
                  const item = {
                    label: label,
                    color1: color1,
                    color2: color2,
                    image: image,
                    custom: true,
                  };
                  _jsonData.push(item);
                  _isRender = true;
                  _this.initWithJson();
                  _this.saveJsonToModule();

                  $column.data('gfsettinggroup').hidePopup();
                }
              });
          }
        });
    };

    this.getJsonData = function () {
      return JSON.parse(JSON.stringify(_jsonData));
    };

    this.saveJsonToModule = function (jsonData) {
      if (jsonData != undefined) {
        _jsonData = jsonData;
        _isRender = true;
      }

      const customSwatches = _jsonData.filter(function (swatch) {
        if (swatch.custom) {
          return true;
        } else {
          return false;
        }
      });

      let jsonHtml = JSON.stringify(customSwatches);
      jsonHtml = HELPER.compressHTML(jsonHtml);

      let dataVer = typeof $targetElement.attr('data-ver') !== 'undefined' ? $targetElement.attr('data-ver') : '1';
      dataVer = parseInt(dataVer);
      if (dataVer < 2) {
        jsonHtml = jsonHtml.replace(/'/gi, '"');
      }
      $element.val(jsonHtml).attr('value', jsonHtml).trigger('input-change');

      _this.settings.detectChange();
    };

    this.init();
  };
  jQuery.fn.gfSwatcher = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfswatcher')) {
        const plugin = new jQuery.gfSwatcher(this, options);
        jQuery(this).data('gfswatcher', plugin);
      }
    });
  };
})(jQuery);
